export var DefaultPageBreakpoints;
(function (DefaultPageBreakpoints) {
    DefaultPageBreakpoints[DefaultPageBreakpoints["Small"] = 300] = "Small";
    DefaultPageBreakpoints[DefaultPageBreakpoints["Medium"] = 768] = "Medium";
    DefaultPageBreakpoints[DefaultPageBreakpoints["Large"] = 1024] = "Large";
})(DefaultPageBreakpoints || (DefaultPageBreakpoints = {}));
export var Usage;
(function (Usage) {
    Usage["Thumbnail"] = "thumbnail";
    Usage["Result"] = "result";
    Usage["Card"] = "card";
    Usage["Main"] = "main";
    Usage["Full"] = "full";
})(Usage || (Usage = {}));
